import ErrorScreenWrapper from './ErrorScreenWrapper';
import { Refresh as RetryIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import EmailNotAllowedErrorScreenContent from './EmailNotAllowedErrorScreenContent';
import GenericErrorScreenContent from './GenericErrorScreenContent';
import useProcessError from './useProcessError';
import React from 'react';
import { type HTMLDivProps } from '@/lib/types';
import { Button } from '@mui/material';

type ErrorScreenProps = HTMLDivProps & {
  error: unknown;
  onDismiss: (event: React.MouseEvent<HTMLButtonElement>) => void;
  visible: boolean;
};

const ErrorScreen = ({
  error,
  onDismiss,
  visible,
  ...props
}: ErrorScreenProps) => {
  const errorCode = useProcessError(error);

  return (
    <ErrorScreenWrapper visible={visible} {...props}>
      {errorCode === 'auth/email-disallowed' ? (
        <EmailNotAllowedErrorScreenContent />
      ) : (
        <GenericErrorScreenContent errorCode={errorCode} />
      )}
      <Button
        variant="contained"
        color="error"
        onClick={onDismiss}
        startIcon={<RetryIcon />}
        disabled={!visible}
        disableElevation
      >
        <FormattedMessage id="login.error_screen.retry_button" />
      </Button>
    </ErrorScreenWrapper>
  );
};

export default ErrorScreen;
